function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null);

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M23.625,0H3.375A3.376,3.376,0,0,0,0,3.375v29.25A3.376,3.376,0,0,0,3.375,36h20.25A3.376,3.376,0,0,0,27,32.625V3.375A3.376,3.376,0,0,0,23.625,0Zm-13.5,2.25h6.75a1.125,1.125,0,0,1,0,2.25h-6.75a1.125,1.125,0,0,1,0-2.25Zm3.375,9A4.5,4.5,0,1,1,9,15.75,4.5,4.5,0,0,1,13.5,11.25ZM21.375,27.9A1.474,1.474,0,0,1,19.8,29.25H7.2A1.474,1.474,0,0,1,5.625,27.9V26.55c0-2.236,2.116-4.05,4.725-4.05H10.7a7.242,7.242,0,0,0,5.6,0h.352c2.609,0,4.725,1.814,4.725,4.05Z"
});

const SvgIconAFamiliares = (_ref) => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 36,
    viewBox: "0 0 27 36",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconAFamiliares, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Icon_AFamiliares.dff5f2f7.svg";
export { ForwardRef as ReactComponent };